import { MessageEnvelope } from '@cds/push';
import { createAction, props } from '@ngrx/store';

import { PickId } from '../../core/picks/pick-id';
import BetslipPickActions from './actions';

export interface IPickSubscriptionPayload {
    pickId: PickId;
    context: string[];
    fromHybridFixture?: boolean;
}

export default class PickSubscriptionActions {
    static readonly ACTION_SCHEMA = `${BetslipPickActions.ACTION_SCHEMA}/subscriptions`;

    private static readonly SUBSCRIBE_TO_PICK = `${PickSubscriptionActions.ACTION_SCHEMA}/SUBSCRIBE_TO_PICK`;
    private static readonly UNSUBSCRIBE_FROM_PICK = `${PickSubscriptionActions.ACTION_SCHEMA}/UNSUBSCRIBE_FROM_PICK`;
    private static readonly SUBSCRIBE_TO_PICKS = `${PickSubscriptionActions.ACTION_SCHEMA}/SUBSCRIBE_TO_PICKS`;
    private static readonly UNSUBSCRIBE_FROM_PICKS = `${PickSubscriptionActions.ACTION_SCHEMA}/UNSUBSCRIBE_FROM_PICKS`;

    private static readonly UNSUBSCRIBE_ALL = `${PickSubscriptionActions.ACTION_SCHEMA}/UNSUBSCRIBE_ALL`;

    private static readonly EVENT_UPDATED = `${PickSubscriptionActions.ACTION_SCHEMA}/EVENT_UPDATED`;
    private static readonly FIXTURE_UPDATED = `${PickSubscriptionActions.ACTION_SCHEMA}/FIXTURE_UPDATED`;

    static subscribeToPick = createAction(PickSubscriptionActions.SUBSCRIBE_TO_PICK, props<{ pick: IPickSubscriptionPayload }>());
    static unsubscribeFromPick = createAction(PickSubscriptionActions.UNSUBSCRIBE_FROM_PICK, props<{ pickId: PickId }>());

    static subscribeToPicks = createAction(PickSubscriptionActions.SUBSCRIBE_TO_PICKS, props<{ picks: IPickSubscriptionPayload[] }>());
    static unsubscribeFromPicks = createAction(PickSubscriptionActions.UNSUBSCRIBE_FROM_PICKS, props<{ pickIds: PickId[] }>());

    static unsubscribeAll = createAction(PickSubscriptionActions.UNSUBSCRIBE_ALL);

    static eventUpdated = createAction(PickSubscriptionActions.EVENT_UPDATED, props<{ message: MessageEnvelope }>());
    static fixtureUpdated = createAction(PickSubscriptionActions.FIXTURE_UPDATED, props<{ message: MessageEnvelope }>());
    static betBuilderGroupUpdated = createAction(
        `${PickSubscriptionActions.ACTION_SCHEMA}/BETBUILDER_GROUP_UPDATED`,
        props<{ message: MessageEnvelope }>(),
    );
}
